/**
 * Do not edit directly
 * Generated on Fri, 25 Nov 2022 14:07:59 GMT
 */
export var heading = "Merrion Sans";
export var body = "Merrion Sans";
//# sourceMappingURL=fonts.js.map